import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("You're on the list — welcome to Elegant Affairs.");
      setEmail("");
    } catch (err) {
      toast.error("Could not subscribe. Please verify your email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer className="bg-[#121212] text-[#f9f9f6] mt-32" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-7">
            <p className="eyebrow text-[#f9f9f6]/60">Newsletter</p>
            <h2 className="font-display text-4xl md:text-6xl mt-4 leading-[1.05] tracking-tight">
              First access. Curated edits. <em className="font-light">Direct delivery.</em>
            </h2>
            <form onSubmit={subscribe} className="mt-10 flex flex-col sm:flex-row gap-4 max-w-2xl" data-testid="newsletter-form">
              <input
                type="email"
                required
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 bg-transparent border-b border-white/30 py-3 px-1 text-lg placeholder:text-white/40 focus:outline-none focus:border-white"
                data-testid="newsletter-email-input"
              />
              <button
                type="submit"
                disabled={loading}
                className="bg-[#f9f9f6] text-[#121212] px-8 py-4 uppercase tracking-[0.22em] text-xs font-medium hover:bg-[#f9f9f6]/90 transition-colors disabled:opacity-60"
                data-testid="newsletter-submit"
              >
                {loading ? "Sending…" : "Subscribe"}
              </button>
            </form>
          </div>

          <div className="md:col-span-5 grid grid-cols-2 gap-8">
            <div>
              <p className="eyebrow text-[#f9f9f6]/60">Shop</p>
              <ul className="mt-5 space-y-3 text-sm">
                <li><Link to="/shop" className="hover:opacity-70" data-testid="footer-shop">Collection</Link></li>
                <li><Link to="/about" className="hover:opacity-70" data-testid="footer-about">About</Link></li>
                <li><Link to="/about#concierge" className="hover:opacity-70" data-testid="footer-style-advice">Style Advice</Link></li>
              </ul>
            </div>
            <div>
              <p className="eyebrow text-[#f9f9f6]/60">Help</p>
              <ul className="mt-5 space-y-3 text-sm">
                <li>
                  <Link to="/shipping-returns" className="hover:opacity-70" data-testid="footer-shipping-returns">
                    Shipping & Returns
                  </Link>
                </li>
                <li>
                  <Link to="/order/track" className="hover:opacity-70" data-testid="footer-track-order">
                    Track your order
                  </Link>
                </li>
                <li>
                  <Link to="/authenticity" className="hover:opacity-70" data-testid="footer-authenticity">
                    Authenticity
                  </Link>
                </li>
                <li>
                  <Link to="/about#concierge" className="hover:opacity-70" data-testid="footer-contact">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/privacy" className="hover:opacity-70" data-testid="footer-privacy">
                    Privacy
                  </Link>
                </li>
                <li>
                  <Link to="/terms" className="hover:opacity-70" data-testid="footer-terms">
                    Terms
                  </Link>
                </li>
                <li>
                  <a
                    href="mailto:concierge@elegantaffairs.shop?subject=UNSUBSCRIBE"
                    className="hover:opacity-70"
                    data-testid="footer-unsubscribe"
                  >
                    Unsubscribe
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-24 md:mt-32 border-t border-white/10 pt-10 flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div>
            <p className="font-display text-[16vw] md:text-[11vw] leading-[0.9] tracking-tighter font-black select-none">
              Elegant<span className="italic font-medium ml-2 md:ml-4">Affairs</span>
            </p>
            <p className="eyebrow text-[#f9f9f6]/60 mt-6">The Epitome of Luxury</p>
          </div>
        </div>
        <div className="mt-10 flex flex-col md:flex-row justify-between gap-4 text-xs uppercase tracking-[0.22em] text-white/50">
          <span>© {new Date().getFullYear()} Elegant Affairs</span>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-bottom-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-bottom-terms">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
